import Button from '../ButtonNew'
import ArrowRightIcon from '../../assets/icons/common/arrow-right.svg'
import InfoIcon from '../../assets/icons/info.svg'
import Text from '../Text'
import useProceedButton from '../../hooks/useProceedButton'

const ProceedButton = ({
  onMoveNext = () => {},
  onSkip = () => {},
  isLastStep,
  disabled = false,
  btnText = null,
  infoText = null,
  canSkip = false,
}) => {
  const { loading, handleProceed, handleSkip, buttonText } = useProceedButton({
    isLastStep,
    onMoveNext,
    onSkip,
    btnText,
  })

  return (
    <div className="fixed bottom-0 left-0 right-0 p-4 min-w-sm max-w-lg mx-auto w-full bg-white">
      {infoText && (
        <div className="bg-[#E6F7FF] rounded-lg p-4 flex items-center gap-2 mb-3">
          <img src={InfoIcon} className="w-6 h-6" />
          <Text variant="body" size="small" className="text-[#3D4854]">
            {infoText}
          </Text>
        </div>
      )}
      {canSkip ? (
        <div className="flex gap-3">
          <Button
            fullWidth
            size="xSmall"
            onClick={handleSkip}
            variant="outlined"
            disabled={loading}
          >
            Skip
          </Button>
          <Button
            fullWidth
            size="xSmall"
            onClick={handleProceed}
            disabled={disabled || loading}
          >
            {buttonText}
            <img src={ArrowRightIcon} />
          </Button>
        </div>
      ) : (
        <Button
          fullWidth
          size="xSmall"
          onClick={handleProceed}
          disabled={disabled || loading}
        >
          {buttonText}
          <img src={ArrowRightIcon} />
        </Button>
      )}
    </div>
  )
}

export default ProceedButton
